var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAsyncStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19319_3544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19319_3544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.79896V3.99896C6.5 3.8573 6.45209 3.73855 6.35625 3.64271C6.26042 3.54688 6.14167 3.49896 6 3.49896C5.85833 3.49896 5.73958 3.54688 5.64375 3.64271C5.54792 3.73855 5.5 3.8573 5.5 3.99896V5.98646C5.5 6.05313 5.5125 6.11771 5.5375 6.18021C5.5625 6.24271 5.6 6.29896 5.65 6.34896L7.3 7.99896C7.39167 8.09063 7.50834 8.13646 7.65 8.13646C7.79167 8.13646 7.90834 8.09063 8 7.99896C8.09167 7.9073 8.1375 7.79063 8.1375 7.64896C8.1375 7.5073 8.09167 7.39063 8 7.29896L6.5 5.79896ZM6 10.999C5.30833 10.999 4.65833 10.8677 4.05 10.6052C3.44167 10.3427 2.9125 9.98646 2.4625 9.53646C2.0125 9.08646 1.65625 8.5573 1.39375 7.94896C1.13125 7.34063 1 6.69063 1 5.99896C1 5.3073 1.13125 4.6573 1.39375 4.04896C1.65625 3.44063 2.0125 2.91146 2.4625 2.46146C2.9125 2.01146 3.44167 1.65521 4.05 1.39271C4.65833 1.13021 5.30833 0.998962 6 0.998962C6.69167 0.998962 7.34167 1.13021 7.95 1.39271C8.55834 1.65521 9.0875 2.01146 9.5375 2.46146C9.9875 2.91146 10.3438 3.44063 10.6063 4.04896C10.8688 4.6573 11 5.3073 11 5.99896C11 6.69063 10.8688 7.34063 10.6063 7.94896C10.3438 8.5573 9.9875 9.08646 9.5375 9.53646C9.0875 9.98646 8.55834 10.3427 7.95 10.6052C7.34167 10.8677 6.69167 10.999 6 10.999ZM6 9.99896C7.10834 9.99896 8.05209 9.60938 8.83125 8.83021C9.61042 8.05105 10 7.1073 10 5.99896C10 4.89063 9.61042 3.94688 8.83125 3.16771C8.05209 2.38855 7.10834 1.99896 6 1.99896C4.89167 1.99896 3.94792 2.38855 3.16875 3.16771C2.38958 3.94688 2 4.89063 2 5.99896C2 7.1073 2.38958 8.05105 3.16875 8.83021C3.94792 9.60938 4.89167 9.99896 6 9.99896Z",
    fill: "#2563EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAsyncStatus);
export default __webpack_public_path__ + "static/media/ic_async_status.dd2d12b15d42b1a8e55a397c6e7e1343.svg";
export { ForwardRef as ReactComponent };